module.exports = __webpack_public_path__ + "img/环境评估select.e071335c.svg";